export * from './InformationTabs.desktop'
export * from './InformationTabs.mobile'
export * from './InformationTabs'
